import React, { Component } from 'react';
import './footer.css';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import createNewCard from './images/CreateNewCard.png';
import createNewCard2 from './images/CreateNewCard2.png';
import createNewCard3 from './images/CreateNewCard3.png';

class Home extends Component {

  constructor(props) {
      super(props);
      this.state = {

      }
      this.carouselStart=this.carouselStart.bind(this);
      this.pic2=this.pic2.bind(this);
      this.pic3=this.pic3.bind(this);

    }

   carouselStart() {
     this.setState({image: createNewCard});
      window.setTimeout(this.pic2, 4000);
  }


   pic2(){
      this.setState({image: createNewCard2});
      window.setTimeout(this.pic3, 4000);
   }

    pic3(){
      this.setState({image: createNewCard3});
      window.setTimeout(this.carouselStart, 4000);
   }

   componentWillMount() {
     this.carouselStart();
   }

   render(){

  return(
    <div className="main">
      <h1 className="main-h1">Gift Cards...Fast!</h1>
      <div className="carousel-holder">
      <div className="carousel" style={{ backgroundImage: `url(${this.state.image})` }}></div>
    </div>
    <div className="faster-holder">
      <p className="faster">A Better, Faster Giftcard Experience</p>
    </div>
      <div className="lets-go-holder">
        <button className="lets-go"><Link to="/letsGo">Let's Go!</Link></button>
      </div>
    </div>
  )}

}










export default Home;



// WEBPACK FOOTER //
// ./src/home.js